// Resources
import { GENERAL_ERROR, GENERAL_ERROR_SUPPORT_MODE } from "../../resources";
import { catchError } from "../../catchErrors";

// Components
import { addToast } from "../../components/toasts";

// Settings
import { POST_SUBSCRIBE_OFFER_URL } from "./settings";
import { COUNTRY_KEY, FRONT_OFFICE_URL } from "../../settings";

// Functions
import {
  getHaveKillerQuestions,
  showKillerQuestionsModal,
} from "./killer-questions";
import { getHaveExperience, showAddExperienceModal } from "./experiences";
import { getHaveFormation, showAddFormationModal } from "./formations";
import { Stepper } from "../../components/stepper";
import { getSession } from "../../helpers";
import { closeSpecificModal, showModal, EuiModalSize } from "../../components/modal";
import { initRelatedOffersComp } from "../../components/relatedOffers";

const applyOfferModal = () => $("#applyOfferModal");
const stepBackButtons = () => $("[apply-offer-step-back]");
const offerId = () => $(".psf-offer-detail").attr("data-offerid");

let haveExperience: boolean;
let offerRequireExperience: boolean;
let haveFormations: boolean;
let offerRequireFormation: boolean;
let haveKillerQuestions: boolean;
export let stepper: Stepper;

declare global {
  interface Window {
    pushUTM: Function;
    addBrazeEvent: Function;
  }
}

$(() => {
  $("[subscribe-offer]").on("click", async () => {
    const offerDetail = document.getElementsByClassName("psf-offer-detail")[0];
    offerRequireFormation = !(
      offerDetail.getAttribute("data-isuntrained") === "True"
    );
    offerRequireExperience = !(
      offerDetail.getAttribute("data-isinexperienced") === "True"
    );

    window.dataLayer?.push({
      event: "BotonInscripcionOferta",
    });
    disableSubscribeOfferButton();

    haveExperience = await getHaveExperience();
    haveFormations = await getHaveFormation();
    haveKillerQuestions = await getHaveKillerQuestions();

    if (haveExperience || !offerRequireExperience) {
      $("[experience-step]").remove();
    }

    if (haveFormations || !offerRequireFormation) {
      $("[formation-step]").remove();
    }

    if (!haveKillerQuestions) {
      $("[killer-questions-form]").remove();
    }

    stepper = new Stepper($("#applyOfferStepper"));

    stepBackButtons().off("click", doStepBack);
    stepBackButtons().on("click", doStepBack);

    stepper.setStep(0);
    if (!haveExperience && offerRequireExperience) {
      setTimeout(() => showAddExperienceModal(), 1000);
    } else if (!haveFormations && offerRequireFormation) {
      setTimeout(() => showAddFormationModal(), 1000);
    } else if (haveKillerQuestions) {
      setTimeout(() => showKillerQuestionsModal(), 1000);
    } else subscribeOffer();
  });

  initRelatedOffersComp();
});

$(() => {
  $(document).on("click", "[share-button]", (event) => {
    const currentUrl: string = $("meta[name='og:url']").attr("content")!;
    const socialNetwork: string = $(event.currentTarget).data("media");

    switch (socialNetwork) {
      case "facebook":
        window.open(
          "http://www.facebook.com/sharer/sharer.php?u=" + currentUrl,
          "_blank",
          "toolbar=no,left=0, top=0, width=500,height=400"
        );
        break;
      case "twitter":
        let town: string = $("meta[name='og:town']").attr("content")!;
        const title: string = $("meta[name='og:title']").attr("content")!;
        const textParam: string = `${title} ${town} - Eurofirms @EUROFIRMS`;

        if (town.indexOf("-") > -1) {
          town = town.substr(0, town.lastIndexOf("-"));
        }

        window.open(
          "https://twitter.com/intent/tweet?original_referer=" +
            currentUrl +
            "&ref_src=twsrc%5Etfw&text=" +
            textParam +
            "&tw_p=tweetbutton&url=" +
            currentUrl,
          "_blank",
          "toolbar=no,left=0, top=0, width=500,height=400"
        );
        break;
      case "linkedin":
        window.open(
          "https://www.linkedin.com/sharing/share-offsite/?url=" + currentUrl,
          "_blank",
          "toolbar=no,left=0, top=0, width=500,height=400"
        );
        break;
    }
  });
});

export function subscribeOffer() {
  closeSpecificModal('#applyOfferModal');
  $.post(POST_SUBSCRIBE_OFFER_URL)
    .done(() => {
      showModal("#offerSubscribedModal", { overlayClose: false, size: EuiModalSize.S });

      const offerIdValue = offerId();
      const session = getSession();
      window.pushUTM(
        `${FRONT_OFFICE_URL}UTMs/InsertJobApplyUTMEvent?orderGuid=${offerIdValue}`,
        session.jwToken
      );
      if (window.addBrazeEvent)
        window.addBrazeEvent("B2C - Apply to a job offer");
    })
    .fail((x) => {
      if (x.status == 412) addToast(GENERAL_ERROR_SUPPORT_MODE, "info");
      else addToast(GENERAL_ERROR);
    })
    .catch(catchError)
    .always(() => {
      enableSubscribeOfferButton();
    });
}

export function finishAddExperienceModal() {
  if (!haveFormations && offerRequireFormation) {
    showAddFormationModal();
    stepper.setStep(2);
  } else if (haveKillerQuestions) {
    showKillerQuestionsModal();
    stepper.setStep(2);
  } else subscribeOffer();
}

export function finishAddFormationModal() {
  if (haveKillerQuestions) {
    showKillerQuestionsModal();
    !haveExperience && offerRequireExperience
      ? stepper.setStep(4)
      : stepper.setStep(2);
  } else subscribeOffer();
}

export function finishKillerQuestionsModal() {
  subscribeOffer();
}

export function enableSubscribeOfferButton() {
  $("[subscribe-offer]").prop("disabled", false);
}

export function onCloseModalExperiences() {
  window.dataLayer?.push({
    event: "SalirExperienciaOferta",
  });
  enableSubscribeOfferButton();
}

export function onCloseModalFormations() {
  window.dataLayer?.push({
    event: "SalirFormacionOferta",
  });
  enableSubscribeOfferButton();
}

export function onCloseModalKillerQuestions() {
  window.dataLayer?.push({
    event: "SalirKillerQuestionsOferta",
  });
  enableSubscribeOfferButton();
}

export function disableSubscribeOfferButton() {
  $("[subscribe-offer]").prop("disabled", true);
}

function doStepBack() {
  if (stepper.index != 0) stepper.prev();
  else {
    closeSpecificModal('#applyOfferModal');
  }
}
